<template>
    <button @click="openFilter" class="search-panel__button-open">
        Выбрать недвижимость
    </button>
</template>

<script>
export default {
    methods: {
        openFilter() {
            this.$emit('openFilter');
        }
    }
};
</script>
